import { PaymentOperationResult } from "./payment-types"

export interface CreateJourneyResult {
    success:boolean,
    journeyId?:string,
    errorMessage?:string
}

export interface AcceptInvitationResult {
    success:boolean,
    errorMessage?:string
}


export enum ReasonTypes {
    UNMAPPED_ERROR,
    JOURNEY_NOT_FOUND,
    USER_GROUP_NOT_FOUND,
    PRODUCT_NOT_FOUND,
    JOURNEY_MEMBER_HAS_CONVERSATIONS,
    CANT_REMOVE_JOURNEY_LEADER,

    USER_NOT_JOURNEY_LEADER,
    USER_NOT_JOURNEY_MEMBER,
    JOURNEY_MEMBER_ALREADY_INACTIVE,

    GROUP_JOURNEY_CREATED,

    JOURNEY_MEMBER_DEACTIVATED,
    JOURNEY_MEMBER_REMOVED,
    JOURNEY_DEACTIVATED,

    JOURNEY_LIST,

    INVITATION_VALID,
    INVITATION_CREATED,
    INVITATION_NOT_FOUND,
    INVITATION_INVALID,
    INVITATION_ACCEPTED,
    USER_IS_LEADER_CANNOT_ACCEPT_OWN_INVITE,
    USER_ALREADY_IN_GROUP,
    USER_DOESNT_OWN_PRODUCT_CANNOT_ACCEPT_INVITATION,

    CHAT_MESSAGES_RESULT,
    CHAT_MSG_SENT,

    USER_ALREADY_OWNS_PRODUCT,
    NO_PURCHASE_FOR_USER_AND_PRODUCT,
}

export enum RequestType {
    RETRIEVE_INVITE="RETRIEVE_INVITE",
    CREATE_INVITE="CREATE_INVITE",
    ACCEPT_INVITE="ACCEPT_INVITE",

    CREATE_JOURNEY="CREATE_JOURNEY",
    GET_USER_JOURNEYS="GET_USER_JOURNEYS",
    CLOSE_JOURNEY="CLOSE_JOURNEY",
    EXIT_JOURNEY="EXIT_JOURNEY",
    REMOVE_MEMBER="REMOVE_MEMBER",

    SEND_CHAT_MESSAGE="SEND_CHAT_MESSAGE",
    READ_CHAT_MESSAGES="READ_CHAT_MESSAGES",

    CREATE_PAYMENT_PROFILE="CREATE_PAYMENT_PROFILE",
    GET_OR_CREATE_PAYMENT_TRANSACTION="GET_OR_CREATE_PAYMENT_TRANSACTION",
    GET_TRANSACTION_INFO="GET_TRANSACTION_INFO",
    CONFIRM_FAKE_PAYMENT="CONFIRM_FAKE_PAYMENT",
}
    
export interface BackendRequest {
    type: RequestType,

    inviteId?:string,
    groupId?:string,
    productId?:string,
    journeyName?:string,
    userId?:string,
    
    journeyId?:string,
    chatId?:string,
    content?:string,

    payment?:{
        redirectUrl?:string,
        taxNumber?:string,
        userName?:string,
        transactionId?:string,
    }
}
export interface BackendResponse {
    success:boolean,
    errorMsg?:string,
    chatOperResult?:ChatOperationResult,
    inviteOperResult:InviteOperationResult,
    journeyOperResult?:JourneyOperationResult
    paymentOperResult?:PaymentOperationResult
}


export interface ProductOperationResult {
    success: boolean,
    msg?: string,
    reason?: ReasonTypes,
    userProductId?: string,

}

export interface ChatOperationResult {
    success: boolean,
    messages?:{
        id:string,
        senderId:string,
        dateTime:string,
        content:string,
    }[]
    msg?: string
    reason?: ReasonTypes
}
export interface InviteOperationResult {
    success: boolean,
    inviteId?: string,
    productId?:string,
    productTitle?: string,
    journeyName?: string,
    coverImage?: string,
    productSubtitle?: string,
    userName?: string,
    userOwned?:boolean
    msg?: string
    reason?: ReasonTypes
}
export interface JourneyOperationResult {
    success: boolean,
    journeyId?:string,
    userGroupId?:string,
    msg?: string
    reason?: ReasonTypes,
    journeyList?:GJData[]
}

export type GJDataMember = {
    id:string,
    userId:string,
    sub:string,
    name:string,
    avatar:string
  }
  export type GJData = {
    id:string,
    productId:string,
    name:string,
    owner:string,
    ownerUserId:string,
    members:GJDataMember[]
}

//----------------------
// NOTIFICATION TYPES
//----------------------

export enum GroupNotificationType {
    NEW_CHAT_MESSAGE="[GROUP]:NEW_CHAT_MESSAGE",
    USER_ADDED="[GROUP]:USER_ADDED",
    USER_REMOVED="[GROUP]:USER_REMOVED",
    GROUP_CLOSED="[GROUP]:GROUP_CLOSED",
    NAME_CHANGED="[GROUP]:NAME_CHANGED",
}

export type GroupNameChangeNotification = {
    groupId:string,
    name:string
}

export type GroupMemberChangeNotification = {
    groupId:string,
    userId:string,
    userData?:{
        sub:string,
        name:string,
        avatar:string
    }
}
export interface GroupMemberData {id:string,userId:string,subPart:string,fullSub:string};

export interface JourneyUserContext {
    sub:string,
    fullSub:string,
    email:string,
    userId:string,
};

export interface CreateVideoRequest {
   title: string,
    description:  string,
    tags:  string[],
    s3ObjectKey:  string,
    published:  string,
    productId:   string,
    contentId:  string,
};

// export type GroupChatMessage = {
//     chatId:string,
//     messageId:string,
//     senderId:string,
//     content:string,
//     dateTime:string
// };